export default __webpack_public_path__ + "static/media/usps.5dbaa382.svg";